const ufeApi = require('services/api/ufeApi');


// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+BI+Rewards+Group+API

function _getBiRewardsGroup(source) {
    let url = '/api/bi/rewards?source=' + source;
    return ufeApi.makeRequest(url, {
        method: 'GET'
    }).then(data => data.errorCode ? Promise.reject(data) : data);
}


function getBiRewardsGroupForCheckout() {
    return _getBiRewardsGroup('checkout');
}

function getBiRewardsGroupForProfile() {
    return _getBiRewardsGroup('profile');
}

function getBiRewardsGroupForSnapshot() {
    return _getBiRewardsGroup('snapshot');
}

function getBiRewardsGroupForOrderConf() {
    return _getBiRewardsGroup('orderConfirmation');
}


module.exports = {
    getBiRewardsGroupForCheckout,
    getBiRewardsGroupForProfile,
    getBiRewardsGroupForSnapshot,
    getBiRewardsGroupForOrderConf
};
